import { render, staticRenderFns } from "./OrganisationMembers.vue?vue&type=template&id=72facf3f&scoped=true&"
import script from "./OrganisationMembers.vue?vue&type=script&lang=js&"
export * from "./OrganisationMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72facf3f",
  null
  
)

export default component.exports